export enum EnumOperationType {
  Withdraw = 1,
  Sweep = 2,
  Uniswap = 3,
}
